import React from "react";
import { motion } from "framer-motion";
import { LuWargos } from "../../atoms";
import capa1 from "../../../assets/imgs/capa1.png";
import baseLogo from "../../../assets/imgs/baseLogo.png";
import base from "../../../assets/imgs/base.png";
import flecha from "../../../assets/imgs/flecha.png";
import { cn } from "../../../utils/general";
import styles from "./roulette-wheel.module.css";

const ORIGINAL_OUTER = 660;    // diámetro de diseño original
const ORIGINAL_INNER = 600;    // diámetro interior original
const ORIGINAL_LOGO = 250;
const ORIGINAL_CIRCLE = 140;
const ORIGINAL_ICON = 80;
const ORIGINAL_ARROW_TOP = 4;
const ORIGINAL_ARROW_HEIGHT = 50;

const RouletteWheel = ({
  canvasRef,
  rotate,
  controls,
  className = "",
  size = ORIGINAL_OUTER,
}) => {
  // factor de escala relativo al diseño original
  const scale = size / ORIGINAL_OUTER;

  // dimensiones escaladas
  const innerSize    = ORIGINAL_INNER    * scale;
  const logoSize     = ORIGINAL_LOGO     * scale;
  const circleSize   = ORIGINAL_CIRCLE   * scale;
  const iconSize     = ORIGINAL_ICON     * scale;
  const arrowTop     = ORIGINAL_ARROW_TOP* scale;
  const arrowHeight  = ORIGINAL_ARROW_HEIGHT * scale;

  return (
    <div
      className={cn("relative flex items-center justify-center rounded-full bg-gray-200 select-none", className)}
      style={{ width: size, height: size }}
    >
      {/* fondo */}
      <img
        src={base}
        alt="fondo rueda"
        className={cn("absolute z-[10]", styles.positionImage)}
        style={{ width: size, height: size }}
      />

      {/* canvas giratorio */}
      <motion.canvas
        ref={canvasRef}
        width={innerSize}
        height={innerSize}
        animate={controls}
        style={{
          rotate,
          width: innerSize,
          height: innerSize,
        }}
        className={cn("absolute rounded-full z-[20]")}
      />

      {/* capa decorativa */}
      <img
        src={capa1}
        alt="capa decorativa"
        className={cn("absolute z-[50]", styles.positionImage)}
        style={{ width: innerSize, height: innerSize }}
      />

      {/* logo central */}
      <img
        src={baseLogo}
        alt="logo central"
        className={cn("absolute z-[60]", styles.positionImage)}
        style={{ width: logoSize, height: logoSize }}
      />

      <div
        className={cn("absolute rounded-full bg-black z-[65]", styles.positionImage)}
        style={{ width: circleSize, height: circleSize }}
      />

      <LuWargos
        className={cn("absolute z-[70] text-white", styles.positionImage)}
        size={iconSize}
      />

      <img
        src={flecha}
        id="wheel-pin"
        alt="indicador"
        className="absolute z-[100] !translate-y-0"
        style={{
          top: arrowTop,
          height: arrowHeight,
        }}
      />
    </div>
  );
};

export default RouletteWheel;
